import Base from "./Base.js";

import {
  getJobOpportunity,
  getJobOpportunityAISkillsForSearch,
  getJobOpportunityEvents,
  getNextJobOpportunityMatches,
  listJobOpportunityMatches,
  listJobOpportunitys,
  listSimilarJobOpportunities,
  getJobOpportunityId,
  reRankHitsForJob,
} from "api/graphql/queries.js";
import { updateJobOpportunity } from "./graphql/mutations.js";

export default class JobsAPI extends Base {
  list(payload) {
    return this.apiClient.request({ query: listJobOpportunitys, payload });
  }

  get(payload) {
    return this.apiClient.request({ query: getJobOpportunity, payload });
  }

  getByExternalId(payload) {
    return this.apiClient.request({ query: getJobOpportunityId, payload });
  }

  update(payload) {
    return this.apiClient.request({ query: updateJobOpportunity, payload });
  }

  getEvents(payload) {
    return this.apiClient.request({ query: getJobOpportunityEvents, payload });
  }

  getNextMatches(payload) {
    return this.apiClient.request({
      query: getNextJobOpportunityMatches,
      payload,
    });
  }

  listSimilarJobs(payload) {
    return this.apiClient.request({
      query: listSimilarJobOpportunities,
      payload,
    });
  }

  listMatches(payload) {
    return this.apiClient.request({
      query: listJobOpportunityMatches,
      payload,
    });
  }

  getAISkillsForSearch(payload) {
    return this.apiClient.request({
      query: getJobOpportunityAISkillsForSearch,
      payload,
    });
  }

  async reRankHits(payload) {
    if (process.env.REACT_APP_RE_RANK_JOR_JOB_RESOLVER_STREAM_URL) {
      const res = await this.apiClient.postStreamAndDecompress(
        process.env.REACT_APP_RE_RANK_JOR_JOB_RESOLVER_STREAM_URL,
        { ...payload }
      );

      if (res.error) {
        throw new Error(res.error);
      }

      return res;
    }

    const { data } = await this.apiClient.request({
      query: reRankHitsForJob,
      payload: {
        ...payload,
        hits: JSON.stringify(payload.hits),
      },
    });

    return JSON.parse(data.reRankHitsForJob);
  }
}
